<dff-side [observable]="vm$">
  @if (vm$ | async; as vm) {
    <form [formGroup]="vm.formGroup" novalidate>
      <div>
        <mat-form-field>
          <input
            id="qa-loginoplysninger-email-input"
            matInput
            placeholder="Mailadresse"
            formControlName="mail"
            autocomplete="email"
            aria-label="Mailadresse"
            [attr.aria-disabled]="vm.formGroup.controls.mail.disabled"
            />
            @if (vm.formGroup.controls.mail.hasError('email') && !vm.formGroup.controls.mail.hasError('required')) {
              <mat-error>
                Indtast en gyldig mailadresse.
              </mat-error>
            }
            @if (vm.formGroup.controls.mail.hasError('required')) {
              <mat-error> Udfyld venligst feltet. </mat-error>
            }
          </mat-form-field>
          @if (vm.formGroup.controls.mail.disabled) {
            <button
              id="qa-loginoplysninger-login-button"
              mat-icon-button
              (click)="vm.formGroup.controls.mail.enable(); addFocus('qa-loginoplysninger-email-input')"
              aria-label="Rediger mailadresse"
              aria-controls="qa-loginoplysninger-email-input"
              >
              <mat-icon svgIcon="mine-oplysninger-edit"></mat-icon>
            </button>
          }
          @if (!vm.formGroup.controls.mail.disabled) {
            <span>
              <button
                id="qa-loginoplysninger-email-check-button"
                mat-icon-button
                [disabled]="vm.formGroup.controls.mail.invalid"
                (click)="redigerMail(vm.formGroup)"
                aria-label="Gem mailadresse"
                >
                <mat-icon svgIcon="mine-oplysninger-check"></mat-icon>
              </button>
              <button
                id="annullerMail"
                mat-icon-button
                (click)="annullerRedigerMail(vm.formGroup, vm.installationsoplysninger.mail)"
                aria-label="Annuller redigering af mailadresse"
                >
                <mat-icon svgIcon="mine-oplysninger-close"></mat-icon>
              </button>
            </span>
          }
        </div>
        <div><br /></div>
        @if (vm.rolle !== ejendomsadministrator) {
          <div>
            <div>
              <mat-form-field>
                <input
                  id="qa-loginoplysninger-current-password-input"
                  matInput
                  placeholder="Nuværende kodeord"
                  formControlName="nuvaerendeKodeord"
                  [type]="'password'"
                  autocomplete="current-password"
                  aria-label="Nuværende kodeord"
                  />
                  @if (vm.formGroup.controls.nuvaerendeKodeord.hasError('required')) {
                    <mat-error>
                      Udfyld venligst feltet.
                    </mat-error>
                  }
                </mat-form-field>
              </div>
              <div>
                <mat-form-field>
                  <input
                    id="qa-loginoplysninger-password-input"
                    matInput
                    placeholder="Nyt kodeord"
                    formControlName="nytKodeord"
                    [type]="'password'"
                    autocomplete="new-password"
                    aria-label="Nyt kodeord"
                    />
                    @if (
                      (!vm.formGroup.controls.nytKodeord.hasError('minLength') ||
                      !vm.formGroup.controls.nytKodeord.hasError('maxLength')) &&
                      !vm.formGroup.controls.nytKodeord.hasError('required')
                      ) {
                      <mat-error
                        id="qa-loginoplysninger-newPassword-mat-error"
                        >
                        Kodeord skal være 4-24 tegn.
                      </mat-error>
                    }
                    @if (vm.formGroup.controls.nytKodeord.hasError('required')) {
                      <mat-error> Udfyld venligst feltet. </mat-error>
                    }
                  </mat-form-field>
                </div>
                <div>
                  <mat-form-field>
                    <input
                      id="qa-loginoplysninger-repeat-password-input"
                      matInput
                      placeholder="Gentag nyt kodeord"
                      formControlName="gentagNytKodeord"
                      [type]="'password'"
                      autocomplete="repeat-password"
                      aria-label="Gentag nyt kodeord"
                      />
                      @if (
                        vm.formGroup.controls.gentagNytKodeord.hasError('invalid') &&
                        !vm.formGroup.controls.gentagNytKodeord.hasError('required')
                        ) {
                        <mat-error
                          >
                          De to kodeord stemmer ikke overens.
                        </mat-error>
                      }
                      @if (vm.formGroup.controls.gentagNytKodeord.hasError('required')) {
                        <mat-error> Udfyld venligst feltet. </mat-error>
                      }
                    </mat-form-field>
                  </div>
                  <br />
                  <div>
                    <button
                      id="qa-loginoplysninger-password-change-button"
                      mat-raised-button
                      color="primary"
                      (click)="redigerLoginoplysninger(vm.formGroup)"
                      aria-label="Godkend ændring af kodeord"
                      [attr.aria-disabled]="vm.formGroup.invalid || vm.formGroup.controls.mail.invalid"
                      [disabled]="vm.formGroup.invalid || vm.formGroup.controls.mail.invalid"
                      >
                      Skift kodeord
                    </button>
                  </div>
                </div>
              }
            </form>
          }
        </dff-side>
